import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-custom-template',
  template: ` <ng-container *ngTemplateOutlet="to.template"></ng-container> `,
})
export class FormlyFieldCustomTemplate extends FieldType {}
